export enum FlowType {
  FLOW_TYPE_CALL = 'FLOW_TYPE_CALL',
  FLOW_TYPE_EMAIL = 'FLOW_TYPE_EMAIL',
  FLOW_TYPE_CHAT = 'FLOW_TYPE_CHAT',
  FLOW_TYPE_AUTOMATION = 'FLOW_TYPE_AUTOMATION',
  FLOW_TYPE_MESSENGER = 'FLOW_TYPE_MESSENGER',
}
